import { createStore, applyMiddleware } from 'redux'
import { Reducers } from './reducers/index'
import thunk from 'redux-thunk'
import logger from 'redux-logger'

const configureStore = () => {
  const store = createStore(Reducers, applyMiddleware(thunk, logger))
  return store
}

export default configureStore



// WEBPACK FOOTER //
// ./src/redux/configureStore.js